export enum SoundMarkerListType {
  Sheet = 'Sheet', // corresponds to PlaylistType Sheet and AllSheets
  Device = 'Device'
}